
// // store.js
// import { configureStore } from '@reduxjs/toolkit';
// import createSagaMiddleware from 'redux-saga';
// import rootReducer from './redux/reducers/index.js';
// import rootSaga from './redux/sagas/index.js';


// const sagaMiddleware = createSagaMiddleware();

// const store = configureStore({
//     reducer: rootReducer,
//     middleware: (getDefaultMiddleware) => 
//         getDefaultMiddleware().concat(sagaMiddleware),
// });

// sagaMiddleware.run(rootSaga);

// export default store;

// store.js (or redux/store.js depending on your project structure)
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './redux/reducers/index.js';
import rootSaga from './redux/sagas/index.js';

const sagaMiddleware = createSagaMiddleware();


const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(sagaMiddleware),
    
});


sagaMiddleware.run(rootSaga);

export default store;

